
import { Mixin_list } from "@/mixin";
import { api_user, user } from "@/http/user";
import { api_gifts } from "@/http/gifts";
import { Component } from "vue-property-decorator";
import Page from "@/components/page/index.vue";
import DatePicker from "@/components/datePicker/index.vue";
import Table from "@/components/table/index.vue";
import { api_store, store } from "@/http/store";
import { api_meal, meal } from "@/http/meal";
@Component({
  components: {
    Page,
    Table,
    DatePicker,
  },
})
export default class extends Mixin_list<user>(api_user.get_list) {
  filter = {
    id: "",
    phone: "",
    nickname: "",
    user_type: "",
    create_time_before: "",
    create_time_after: "",
    status: "",
  };
  resetFilter = {
    ...this.filter,
  };
  columns = [
    {
      label: "ID",
      prop: "id",
      width: 80,
    },
    {
      label: "头像",
      slot: "avatar_url",
      prop: "avatar_url",
      width: 80,
    },
    {
      label: "用户照片",
      slot: "image",
      prop: "image",
      width: 100,
    },
    {
      label: "用户名",
      prop: "nickname",
    },
    {
      label: "手机号",
      prop: "phone",
    },
    {
      label: "账户余额",
      prop: "wallet",
    },
    {
      label: "会员卡",
      prop: "member_name",
    },
    {
      label: "店铺名称",
      prop: "",
      slot: "store",
      width: 120,
    },

    {
      label: "创建时间",
      prop: "create_time",
    },
    {
      label: "操作",
      prop: "",
      width: 300,
      slot: "operation",
    },
  ];

  typeList = [
    {
      label: "全部",
      value: "",
    },
    {
      label: "微信",
      value: 1,
    },
    {
      label: "抖音",
      value: 2,
    },
  ];

  statusList = [
    {
      label: "全部",
      value: "",
    },
    {
      label: "禁止",
      value: 0,
    },
    {
      label: "正常",
      value: 1,
    },
  ];
  onUpdateRange([startStr, endStr]: [string, string]) {
    this.filter.create_time_after = startStr;
    this.filter.create_time_before = endStr;
  }
  reset() {
    this.filter = { ...this.filter, ...this.resetFilter };
    (this.$refs.datePicker as Vue & { clearDates: () => void }).clearDates();
    this.find();
  }
  handleClick() {}
  // async handleClick( row:user){
  //     this.$confirm('确认升级吗?').then(async()=>{
  //         await api_user.edit({id:row.id,user_level:row.user_level === 1 ? 2 : row.user_level === 2 ? 3 : 0})
  //         this.get_list()
  //     })
  // }

  click_cell(row: user) {
    // return this.$router.push(`/user/detail/?id=${row.id}`);
  }
  // 获取头像
  get_avatar(value: string) {
    // 如果头像包含http，直接返回
    if (value.includes("http")) {
      return value;
    } else {
      return `https://images.xiyuebiaoju.com/${value}`;
    }
  }
  // 赠送余额
  async give_money(row: user) {
    // 定义PromptResult类型来精确描述$prompt的返回值结构
    // type PromptResult = {
    //   value: string | null;
    //   action: string | null;
    // };

    // 获取余额
     const promptResult: any = await this.$prompt("请输入赠送金额（支持两位小数）", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPattern: /^(0|([1-9]\d*))(\.\d{0,2})?$/, // 允许整数或最多两位小数[8](@ref)
      inputErrorMessage: "请输入有效数字（最多两位小数）"
    });
    console.log(promptResult);
    // 检查用户是否点击了确定按钮并且提供了有效输入
    if (promptResult.value) {
      try {
        // 将输入的字符串转换为数字，这里假设输入始终是有效的数字字符串
         const amount:any = parseFloat(promptResult.value).toFixed(2);
        // 确保转换成功，避免将非数字的字符串传递给API
        if (!isNaN(amount)) {
          await api_gifts
            .give_gifts({
              user_id: Number(row.id),
              amount:Number(amount),
              store: Number(row.store),
              type: 1
            })
            .then((res: any) => {
              this.paymentDialogVisible = true;
              this.qrcode = `https://images.xiyuebiaoju.com/${res.qrcode}`;
              this.startPollingOrderStatus(res.order_no);
            });
        } else {
          this.$message.error("输入的金额无效，请输入数字。");
        }
      } catch (error) {
        this.$message.error("处理赠礼时出现错误。");
      }
    }
  }
  // 注销会员
  async clear_balance(row: user) {
    this.$confirm("确认注销会员吗?").then(async () => {
      await api_user.edit({ id: row.id, status: 0, user_level: "0" });
      this.get_list();
    });
  }
  // 获取门店列表
  storeList: any[] = [];
  async get_store_list() {
    const res = await api_store.get_list({ page_size: 10000 });
    this.storeList = res.results;
  }

  created() {
    this.get_store_list();
  }
  // 获取店铺名称
  get_store(value: string) {
    return this.storeList.find((item: any) => item.id === value)?.name || "---";
  }
  // 修改会员卡
  dialogVisible = false;
  userId = 0;
  openDialog(row: any) {
    if(row.meal_id==0){
      this.$message.error("该用户未办理折扣卡");
      return;
    }
    this.userId = row.id;
    this.meal_id = row.meal_id;
    this.dialogVisible = true;
    this.get_user_level__list(row.store);
  }
  handleClose(done: any) {
    this.$confirm("确认关闭？")
      .then((_) => {
        done();
      })
      .catch((_) => {});
  }
  // 获取会员卡列表
  userLevelList: any[] = [];
  // 会员等级
  meal_id: string = "";
  async get_user_level__list(store:any) {
    const res = await api_meal.get_list({ card_type: 1, page_size: 10000, store_id:"0,"+store });
    const list: any[] = [];
    res.results.forEach((item: any) => {
      (item.value = item.id), (item.label = item.name+"（支付金额："+item.labels+"元，充值余额："+(Number(item.amount)+Number(item.gifts))+"元）");
    });
    this.userLevelList = list.concat(res.results);
  }
  editUserLevel() {
    this.$confirm("确认修改折扣卡吗?").then(async () => {
      await api_user.update_user_meal({ id: this.userId, meal_id: this.meal_id });
      this.get_list();
      this.dialogVisible = false;
    });
  }
  // 付款二维码弹框
  paymentDialogVisible = false;
  qrcode = "";

  pollingTimer: any = null;

  // 关闭付款二维码弹框
  closePaymentDialog() {
    this.paymentDialogVisible = false;
  }
  handleClosePayment(done: any) {
    this.$confirm("确认关闭？")
      .then((_) => {
        if (this.pollingTimer) {
          clearInterval(this.pollingTimer);
          this.pollingTimer = null;
        }
        this.get_list();
        done();
      })
      .catch((_) => {});
  }
  startPollingOrderStatus(orderId: string) {
    if (this.pollingTimer) clearInterval(this.pollingTimer);

    // 立即检查一次状态
    this.checkOrderStatus(orderId);

    // 每30秒轮询一次
    this.pollingTimer = setInterval(() => {
      this.checkOrderStatus(orderId);
    }, 15000);
  }
  // 判断订单是否完成
  async checkOrderStatus(orderId: string) {
    try {
      const res = await api_user.pay_check({ order_no: orderId });
      if (res.pay_status === 1) {
        // 订单成功：关闭弹窗、提示、清除定时器
        clearInterval(this.pollingTimer);
        this.pollingTimer = null;
        this.$message.success("赠送成功");
        this.paymentDialogVisible = false;
        this.get_list();
      }
    } catch (error) {
      console.error("订单状态查询失败:", error);
    }
  }
  beforeDestroy() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }
}
